import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.945.25A6.757 6.757 0 0 0 2 7H.658a.371.371 0 0 0-.263.638l2.093 2.1c.15.15.382.15.532 0l2.093-2.1A.375.375 0 0 0 4.843 7H3.5a5.248 5.248 0 0 1 5.325-5.25c2.79.038 5.138 2.385 5.175 5.175a5.253 5.253 0 0 1-5.25 5.325 5.171 5.171 0 0 1-3.21-1.11.746.746 0 0 0-.99.06c-.315.315-.292.848.06 1.118a6.643 6.643 0 0 0 4.14 1.432 6.757 6.757 0 0 0 6.75-6.945C15.402 3.288 12.463.348 8.945.25ZM8.563 4A.567.567 0 0 0 8 4.563v2.76c0 .262.143.51.368.645l2.34 1.387c.27.158.614.068.772-.195a.568.568 0 0 0-.195-.772l-2.16-1.283v-2.55c0-.3-.255-.555-.562-.555Z",
  fill: "#1E92EF"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };